import { UrlBack } from '@/consts/svg-img';
import bridge from '@/lib/bridge';
import vModule from '@/lib/module';
import clientStore from '@/store/client-store';
import vHistory, { history, VPathKey } from 'lib/history';
import { useObserver } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface IProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  pathKey?: string;
  canGoBack?: boolean;
}

const VNav = (props: IProps) => {
  const { ref, pathKey, canGoBack = true, ...rest } = props;
  const { t } = useTranslation();

  const goBack = () => {
    try {
      const curPathKey = vHistory.getCurrentPathKey();
      const curModuleKey = vModule.getModuleKeyOfPath(curPathKey);
      const pageIdx = vModule.getModulePathArr()[curModuleKey].indexOf(curPathKey as VPathKey);
      const firstModule = clientStore.getClientConfig().start || 'main';
      const isFirstModule = firstModule === curModuleKey;
      if (isFirstModule && pageIdx === 0 && bridge.isWebView()) {
        // close SDK when current page is the first path of first module
        bridge.closeSDK();
      } else {
        history.goBack();
      }
    } catch (error) {
      history.goBack();
    }
  };

  useEffect(() => {
    console.log(t(`page.${vHistory.getCurrentPathKey()}`, ''), vHistory.ifShowNav());
  }, []);

  return useObserver(() => (
    <Wrapper ifShow={vHistory.ifShowNav()} isDemoPage={vHistory.isDemoPage()} {...rest}>
      {vHistory.ifShowNav() && (
        <>
          {!vHistory.cannotCurrentGoBack() && <img src={UrlBack} onClick={goBack} />}
          <div className="v-nav__title">{t(`page.${vHistory.getCurrentPathKey()}`, '')}</div>
        </>
      )}
    </Wrapper>
  ));
};

export default VNav;

const Wrapper = styled.div<{ ifShow: boolean; isDemoPage: boolean }>`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  padding: ${(props) => `${props.theme.paddingTop / props.theme.density + 20}px`} 20px
    ${(props) => `${props.theme.paddingBottom / props.theme.density + 20}px`} 20px;
  background-color: #fff;
  .v-nav {
    &__title {
      display: inline-block;
      font-family: VFont-Bold;
      font-size: 22px;
      color: #333333;
      letter-spacing: 0;
      margin-left: 13px;
    }
  }
  @media only screen and (max-width: ${(props) => `${props.theme.mobileWidth}px`}) {
    background-color: ${(props) => props.theme.mobileBgColor};
    padding: ${(props) => `${props.theme.paddingTop / props.theme.density + 17}px`} 17px
      ${(props) => `${props.theme.paddingBottom / props.theme.density + 17}px`} 17px;
    .v-nav {
      &__title {
        font-family: VFont;
        font-weight: bolder;
        font-size: 18px;
        color: #333333;
        margin-left: 18px;
      }
    }
  }
`;
